//importing firebase
import {Auth} from "./firebase/firebase";
import {onAuthStateChanged, signOut} from "firebase/auth";

//React Components
import {lazy, Suspense, useEffect, useState} from "react";
import {Routes, Route, useNavigate, useLocation} from "react-router-dom";

//Page Components
import PageLayout from "./layouts/PageLayout";
import PageLoading from "./modules/loadingscreen/PageLoading";

//Error pages
import Error404 from "./pages/error/notfound";
import {useAppState} from "./context/state";

//page Icons
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import GridViewIcon from '@mui/icons-material/GridView';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import {useFbGetUser} from "./firebase/firestore/user/fb_getUsers.js";

//pages
const User = lazy(() => import("./pages/account"));
const StartSide = lazy(() => import("./pages/startside"));
const Arrangement = lazy(() => import("./pages/arrangement"));
const Managere = lazy(() => import("./pages/managere"));
const ReadMore = lazy(() => import("./pages/managere/viewManagers"));


//page Links
export const pageLinks = [
    {
        link: "/",
        page: "Startside",
        element: <StartSide/>,
        icon: <GridViewIcon/>,
        displayInSideNav: false,
        needAuth: true
    },
    {
        link: "/login",
        page: "Login",
        element: <User/>,
        icon: "",
        displayInSideNav: false,
        needAuth: false
    },
    {
        link: "/events",
        page: "Alle Arrangement",
        element: <Arrangement/>,
        icon: <CalendarMonthIcon/>,
        displayInSideNav: true,
        needAuth: true
    },
    {
        link: "/managers",
        page: "Managere",
        element: <Managere/>,
        icon: <FormatListBulletedIcon/>,
        displayInSideNav: true,
        needAuth: true
    },
    {
        link: "/managers/:id",
        page: "Manager",
        element: <ReadMore/>,
        icon: "",
        displayInSideNav: false,
        needAuth: true
    },
    {
        link: "*",
        page: "404 Error",
        element: <Error404/>,
        icon: "",
        displayInSideNav: false,
        needAuth: false
    }
]

//----------------[Base - App]---------------------//
//render
export default function App() {
    const [appState, setAppSate] = useAppState();
    const [pageAuthed, setPageAuthed] = useState(false);

    const router = useNavigate();
    const location = useLocation();
    const fbGetUser = useFbGetUser();


    //user validation, checks for admin in auth token
    useEffect(() => {
        //console.log(appState.processing);
        onAuthStateChanged(Auth, (user) => {
            if (user) {
                //console.log(user);
                user.getIdTokenResult()
                    .then(async (tokenResults) => {
                        //console.log(tokenResults);
                        if (tokenResults.claims.admin) {
                            setAppSate({
                                ...appState,
                                user: await fbGetUser(),
                                user_error: false,
                            });
                            setPageAuthed(true);
                            if (location.pathname === "/login") {
                                router("/");
                            }
                        } else {
                            throw "not a valid user";
                        }
                    })
                    .catch(() => {
                        setPageAuthed(false);
                        setAppSate({
                            ...appState,
                            user: null,
                            user_error: "Not a valid user"
                        });
                        void signOut(Auth);
                    });
            } else {
                if (location.pathname !== "/login") {
                    router("/login");
                }
                setAppSate({
                    ...appState,
                    user: null
                });
                setPageAuthed(false);
            }
            setAppSate({...appState, processing: false});
        });
    }, []);
    console.log("page loaded");

    return (
        <>
            {/*Page layout, for all the persistent components on the page*/}

            {/*Use Suspense to lazy-load pages if large amount of content and content takes time to load in,
                 if pages take to long we display a page-loading component*/}
            <Suspense fallback={<PageLoading/>}>
                {pageAuthed ? (
                    //checks if we have a signed-in user, and if we do we render all the routes and pages
                    <PageLayout pageLinks={pageLinks}>
                        <Routes>
                            {/*Loops through all the pages in pageList and creates a route for each of the
                                 elements*/}
                            {pageLinks.map((page, i) => {
                                return <Route path={page.link} element={page.element} key={"page-" + i}/>;
                            })}
                        </Routes>
                    </PageLayout>
                ) : (
                    //If we don't have a signed-out user we return only the routes that don't need a signed-in user
                    <Routes>
                        {/*Loops trough pageList and creates a route for each of the elements that don't need
                             a logged-in user*/}
                        {pageLinks.map((page, i) => {
                            if (!page.needAuth) {
                                return <Route path={page.link} element={page.element} key={"page" + i}/>;
                            } else {
                                return null;
                            }
                        })}
                    </Routes>
                )}
                </Suspense>
        </>
    );

}
